const inicialState = {
  nota: {},
  selectNota: false,  
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/notas/notas.state.js